import constants from "../constants";

const FormConfig = {
  sections: [],
  successPage: {
    title: "¡Felicidades, recibimos tu solicitud de registro!",
    description: [
      `Ya hiciste tu parte, ahora es nuestro turno. En las próximas 24 horas te contactaremos al correo %userEmail%. Por ahora, puedes revisar nuestras capacitaciones de Falabella Seller Center.`
    ],
    buttonShow: true,
    buttonText: "Revisar capacitaciones",
    buttonLink: constants.TRAININGS_URL,
    textReplacedFromForm: {
      "%userEmail%": [constants.INPUT_ID_ADMIN_EMAIL, constants.INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL]
    }
  }
};

export default FormConfig;
